import {
  Autocomplete,
  Button,
  ButtonBase,
  CircularProgress,
  Tab,
  Tabs,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import {
  Fragment,
  memo,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { motion } from 'framer-motion';
import { fadeUp, stepperItem } from 'utils/motion';
import CurrencyFormat from 'components/ui/text-formats/CurrencyFormat';
import { useFormik } from 'formik';
import * as yup from 'yup';
import useNotification from 'hooks/useNotification';
import { NumericFormat } from 'react-number-format';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import StepThreeTabOne from './step-three-tabs/StepThreeTabOne';
import StepThreeTabTwo from './step-three-tabs/StepThreeTabTwo';
import useCurrency from 'hooks/useCurrency';
import CurrencySubContent from 'components/ui/text-formats/CurrencySubContent';
import FormSelectField from 'components/ui/form/FormSelectField';
import { Trans, useTranslation } from 'react-i18next';
import { formatMultiplies } from 'utils/formatOddDecimal';
import { useQuery } from 'react-query';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import REPAIR_TYPE from 'shared/repairTypeList';
import useAuth from 'hooks/useAuth';

const variables = [
  {
    key: '${object}',
    name: 'Obyekt',
  },
  {
    key: '${block}',
    name: 'Blok',
  },
  {
    key: '${entrance}',
    name: 'Padez',
  },
  {
    key: '${stage}',
    name: 'Qavat',
  },
  {
    key: '${home}',
    name: 'Uy raqam',
  },
  {
    key: '${number}',
    name: 'Tartib raqam',
  },
];

const validationSchema = yup.object({
  month: yup
    .number()
    .default(1)
    .required('contract.step.three.validation.month'),
  date: yup
    .date()
    .nullable()
    .typeError('contract.step.three.validation.dateValid')
    .min(
      new Date('Sat Jan 01 2000 00:00:00 GMT+0500'),
      'contract.step.three.validation.dateMin',
    )
    .required('contract.step.three.validation.date'),
  startDate: yup
    .date()
    .nullable()
    .typeError('contract.step.three.validation.startDateValid')
    .min(
      new Date('Sat Jan 01 2000 00:00:00 GMT+0500'),
      'contract.step.three.validation.startDateMin',
    )
    .required('contract.step.three.validation.startDate'),
  sum: yup.number().default(0).required('contract.step.three.validation.sum'),
  left: yup.number().required('contract.step.three.validation.left'),
  discount: yup.number().default(0).optional(),
  interval: yup
    .number()
    .default(1)
    .required('contract.step.three.validation.interval'),
  startPrice: yup
    .number()
    .default(0)
    .required('contract.step.three.validation.startPrice'),
  price: yup
    .number()
    .default(0)
    .required('contract.step.three.validation.priceForSquare'),
  comment: yup.string().optional(),
  contractName: yup
    .string()
    .required('contract.step.three.validation.contractName'),
  operator_id: yup.number().optional(),
});

const StepThree = ({
  appear,
  direction,
  next,
  back,
  homeData,
  setData,
  calculations,
}) => {
  const [{ user }] = useAuth();
  const { t } = useTranslation();
  const [repairData, setRepairData] = useState('');
  const [isRepaired, setIsRepaired] = useState('');
  const [repairedType, setRepairedType] = useState('');
  const [paymentDataList, setPaymentDataList] = useState([]);
  const [paymentDataList2, setPaymentDataList2] = useState([]);
  const [tabValue, setTabValue] = useState('automatic');
  const { currencyData } = useCurrency();
  const [selectedCurrency, setSelectedCurrency] = useState(
    homeData?.isvalute || '0',
  );
  const sendNotification = useNotification();
  const axiosPrivate = useAxiosPrivate();
  const [hasError, setHasError] = useState(false);

  const formik = useFormik({
    initialValues: {
      month: '29',
      date: moment().add(1, 'months').format('YYYY-MM-DD'),
      startDate: moment().format('YYYY-MM-DD'),
      sum: '',
      left: '',
      operator_name: '',
      discount: '0',
      discountPercentage: '0',
      interval: '1',
      startPrice: '0',
      price: '',
      comment: '',
      contractName: '',
      operator_id: '',
      type_id: '',
      lastPayment: '',

      terracePrice: '0',
      innerSum: '0',
      terraceSum: '0',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {},
  });

  const handleNext = () => {
    if (!formik.isValid) {
      formik.handleSubmit();
    }
    let allSumPaymentDataList = paymentDataList.reduce(
      (acc, curr) => acc + curr?.sum,
      0,
    );
    let allSumPaymentDataList2 = paymentDataList2.reduce(
      (acc, curr) => acc + curr?.sum,
      0,
    );

    if (
      (repairData &&
        formik.isValid &&
        tabValue == 'automatic' &&
        Math.floor(allSumPaymentDataList) == Math.floor(formik.values.left)) ||
      (tabValue == 'manually' &&
        Math.floor(allSumPaymentDataList2) == Math.floor(formik.values.left))
    ) {
      const discountPercentage = formik.values.discount / formik.values.sum;
      setData({
        price: formik.values.price,
        sum: +homeData?.terassa ? formik.values.innerSum : formik.values.sum,
        start_price: formik.values.startPrice,
        startDate: formik.values.startDate,
        month: formik.values.month,
        terassasum: formik?.values.terraceSum,
        terassaPrice: formik?.values.terracePrice,
        payments:
          tabValue == 'automatic'
            ? paymentDataList
            : tabValue == 'manually'
              ? paymentDataList2
              : [],
        discount: formik.values.discount,
        discountPercentage,
        name: formik.values.contractName,
        comment: formik.values.comment,
        type_id: formik.values.type_id,
        operator_id: formik.values.operator_id,
        isrepaired: isRepaired,
        isvalute: selectedCurrency,
      });
      next();
    } else if (!repairData) {
      sendNotification({
        msg: t('contract.step.three.alerts.warning.repairType'),
        variant: 'warning',
      });
    } else if (
      (tabValue == 'automatic' &&
        paymentDataList.length !=
          formik.values.month + (calculations?.lastPayment ? 1 : 0)) ||
      (tabValue == 'manually' && paymentDataList2.length != formik.values.month)
    ) {
      sendNotification({
        msg: t('contract.step.three.alerts.warning.paymentsNumber'),
        variant: 'warning',
      });
    } else if (
      (tabValue == 'automatic' &&
        Math.floor(allSumPaymentDataList) != Math.floor(formik.values.left)) ||
      (tabValue == 'manually' &&
        Math.floor(allSumPaymentDataList2) != Math.floor(formik.values.left))
    ) {
      sendNotification({
        msg: t('contract.step.three.alerts.warning.leftPrice'),
        variant: 'warning',
      });
    }
  };

  const handleRepairType = useCallback(
    (type, data) => {
      document
        .querySelectorAll('.repair-type')
        .forEach((item) => item.classList.remove('item-selected'));

      if (type == 'repaired' || type == 'deal_price') {
        setIsRepaired('1');
        document.getElementById(type).classList.add('item-selected');
      } else if (type == 'norepaired') {
        setIsRepaired('0');
        document.getElementById(type).classList.add('item-selected');
      }
      formik.setFieldValue('price', data.price, true);
      if (homeData?.terassa) {
        formik.setFieldValue('terracePrice', data?.terracePrice, true);
        formik.setFieldValue(
          'terraceSum',
          formatMultiplies([+homeData.terassa, +data.terracePrice], 2),
          true,
        );
        formik.setFieldValue(
          'innerSum',
          formatMultiplies([data.square, data.price], 2),
          true,
        );
        formik.setFieldValue(
          'sum',
          formatMultiplies([data.square, data.price], 2) +
            formatMultiplies([+homeData.terassa, +data.terracePrice], 2),
          true,
        );
        formik.setFieldValue(
          'left',
          formatMultiplies([data.square, data.price], 2) +
            formatMultiplies([+homeData.terassa, +data.terracePrice], 2) -
            (data?.startPrice || formik?.values?.startPrice) -
            (data?.discount || formik?.values?.discount),
          true,
        );

        formik.setFieldValue(
          'discountPercentage',
          (formik?.values?.discount /
            formatMultiplies([data.square, data.price], 2) +
            formatMultiplies([+homeData.terassa, +data.terracePrice], 2)) *
            100,
          true,
        );
      } else {
        formik.setFieldValue(
          'sum',
          formatMultiplies([data.square, data.price], 2),
          true,
        );
        formik.setFieldValue(
          'left',
          formatMultiplies([data.square, data.price], 2) -
            (data?.startPrice || formik?.values?.startPrice) -
            (data?.discount || formik?.values?.discount),
          true,
        );

        formik.setFieldValue(
          'discountPercentage',
          (formik?.values?.discount /
            formatMultiplies([data.square, data.price], 2)) *
            100,
          true,
        );
      }
      setRepairData(data);
      setRepairedType(type);
      setSelectedCurrency(data.isvalute);
    },
    [formik?.values?.startPrice, formik?.values?.discount, homeData?.terassa],
  );

  const getPaymentData = useCallback(() => {
    if (
      !isNaN(formik.values.month) &&
      !isNaN(formik.values.left) &&
      formik.values.date &&
      !isNaN(formik.values.interval)
    ) {
      let arr = [];
      const leftWithoutLastPayment =
        formik.values.left - (formik.values.lastPayment ?? 0);
      const priceForMonth = parseInt(
        leftWithoutLastPayment / formik.values?.month,
      );
      const countWithLastPayment =
        formik?.values?.month + (formik.values.lastPayment ? 1 : 0);

      for (let i = 1; i <= countWithLastPayment; i++) {
        if (i == formik.values?.month + 1) {
          arr.push({
            id: i,
            date: moment(formik.values.date)
              .add(formik.values.interval * (i - 1), 'month')
              .format('YYYY-MM-DD'),
            left: formik.values?.left - Math.floor(priceForMonth) * (i - 1),
            sum: formik?.values?.lastPayment,
          });
          continue;
        }

        arr.push({
          id: i,
          date: moment(formik.values.date)
            .add(formik.values.interval * (i - 1), 'month')
            .format('YYYY-MM-DD'),
          left: formik.values.left - Math.floor(priceForMonth) * (i - 1),
          sum: priceForMonth,
        });
      }
      if (arr.length > 1) {
        arr[arr.length - 1] = {
          ...arr[arr.length - 1],
          sum: arr[arr.length - 1].left,
        };
      }
      setPaymentDataList(arr);
    }
  }, [
    formik.values.month,
    formik.values.date,
    formik.values.interval,
    formik.values.left,
    formik?.values?.lastPayment,
  ]);

  const handleCurrencyChange = useCallback(
    (value) => {
      setSelectedCurrency(value);
      if (currencyData && currencyData.sum) {
        if (value == '1') {
          formik.setFieldValue(
            'price',
            parseFloat(
              parseFloat(
                (formik.values.price || '0') / currencyData.sum,
              ).toFixed(1),
            ),
            true,
          );
          formik.setFieldValue(
            'lastPayment',
            parseFloat(
              parseFloat(
                (formik.values.lastPayment || '0') / currencyData.sum,
              ).toFixed(1),
            ),
            true,
          );
          formik.setFieldValue(
            'sum',
            parseFloat(
              parseFloat((formik.values.sum || '0') / currencyData.sum).toFixed(
                1,
              ),
            ),
            true,
          );
          formik.setFieldValue(
            'innerSum',
            parseFloat(
              parseFloat(
                (formik.values.innerSum || '0') / currencyData.sum,
              ).toFixed(1),
            ),
            true,
          );
          formik.setFieldValue(
            'terraceSum',
            parseFloat(
              parseFloat(
                (formik.values.terraceSum || '0') / currencyData.sum,
              ).toFixed(1),
            ),
            true,
          );
          formik.setFieldValue(
            'terracePrice',
            parseFloat(
              parseFloat(
                (formik.values.terracePrice || '0') / currencyData.sum,
              ).toFixed(1),
            ),
            true,
          );
          formik.setFieldValue(
            'startPrice',
            parseFloat(
              parseFloat(
                (formik.values.startPrice || '0') / currencyData.sum,
              ).toFixed(1),
            ),
            true,
          );
          formik.setFieldValue(
            'left',
            parseFloat(
              parseFloat(
                (formik.values.left || '0') / currencyData.sum,
              ).toFixed(1),
            ),
            true,
          );
          formik.setFieldValue(
            'discount',
            parseFloat(
              parseFloat(
                (formik.values.discount || '0') / currencyData.sum,
              ).toFixed(1),
            ),
            true,
          );
        } else if (value == '0') {
          formik.setFieldValue(
            'price',
            parseFloat((formik.values.price || '0') * currencyData.sum),
            true,
          );
          formik.setFieldValue(
            'lastPayment',
            parseFloat((formik.values.lastPayment || '0') * currencyData.sum),
            true,
          );
          formik.setFieldValue(
            'sum',
            parseFloat((formik.values.sum || '0') * currencyData.sum),
            true,
          );
          formik.setFieldValue(
            'innerSum',
            parseFloat((formik.values.innerSum || '0') * currencyData.sum),
            true,
          );
          formik.setFieldValue(
            'terraceSum',
            parseFloat((formik.values.terraceSum || '0') * currencyData.sum),
            true,
          );
          formik.setFieldValue(
            'terracePrice',
            parseFloat((formik.values.terracePrice || '0') * currencyData.sum),
            true,
          );
          formik.setFieldValue(
            'startPrice',
            parseFloat((formik.values.startPrice || '0') * currencyData.sum),
            true,
          );
          formik.setFieldValue(
            'left',
            parseFloat((formik.values.left || '0') * currencyData.sum),
            true,
          );
          formik.setFieldValue(
            'discount',
            parseFloat((formik.values.discount || '0') * currencyData.sum),
            true,
          );
        }
      }
    },
    [currencyData, formik],
  );

  const {
    data: staffList,
    isLoading,
    isFetching,
  } = useQuery({
    queryKey: 'staffSelect',
    queryFn: async function () {
      const response = await axiosPrivate.get('/dictionary/staffes');
      return response.data.data || [];
    },
    enabled: !hasError,
    onError: (error) => {
      setHasError(true);
    },
    retry: false,
  });

  useEffect(() => {
    getPaymentData();
  }, [formik.values]);

  const getContractNameFields = (key) => {
    switch (key) {
      case '${object}':
        return homeData?.blocks?.objects?.name || '';
      case '${block}':
        return homeData?.blocks?.name || '';
      case '${entrance}':
        return homeData?.entrance?.name;
      case '${stage}':
        return homeData?.stage || '';
      case '${home}':
        return homeData?.number || '';
      case '${number}':
        return homeData?.blocks?.objects?.number || '';
      default:
        return '';
    }
  };

  useEffect(() => {
    const c_name = homeData?.blocks?.objects?.c_name;
    if (c_name) {
      let contractName = c_name;
      variables?.forEach((v) => {
        if (contractName?.includes(v?.key)) {
          contractName = contractName?.replaceAll(
            v?.key,
            getContractNameFields(v?.key),
          );
        }
      });

      formik.setFieldValue('contractName', contractName);
    }
  }, [homeData?.blocks?.objects?.c_name]);

  useEffect(() => {
    if (
      (homeData?.isrepaired?.toString() ?? false) &&
      !isRepaired?.toString()
    ) {
      const type =
        homeData?.isrepaired?.toString() ===
        REPAIR_TYPE.REPAIRED.code?.toString()
          ? 'repaired'
          : 'norepaired';

      const pricedefault =
        homeData?.isrepaired?.toString() ===
        REPAIR_TYPE.REPAIRED.code?.toString()
          ? homeData?.repaired
          : homeData?.norepaired;
      if (homeData?.terassa) {
        const terracepricedefault =
          type == 'norepaired'
            ? +homeData?.terassa_price
            : +homeData?.terassa_price_repaired;
        const startpricedefault = parseInt(
          ((homeData?.square * pricedefault +
            +homeData?.terassa * terracepricedefault) *
            homeData?.start) /
            100,
        );
        handleRepairType(type, {
          price: pricedefault,
          square: homeData?.square,
          startPrice: calculations?.startPrice || startpricedefault,
          discount: calculations?.discount || formik?.values?.discount,
          isvalute: calculations?.isvalute || homeData?.isvalute,
          terracePrice: terracepricedefault || '',
        });
      } else {
        const startpricedefault = parseInt(
          (homeData?.square * homeData?.start * pricedefault) / 100,
        );
        handleRepairType(type, {
          price: pricedefault,
          square: homeData?.square,
          startPrice: calculations?.startPrice || startpricedefault,
          discount: calculations?.discount || formik?.values?.discount,
          isvalute: calculations?.isvalute || homeData?.isvalute,
          terracePrice: calculations?.terracePrice || '',
        });
      }
    }
  }, [homeData, calculations]);

  // useEffect(() => {
  //   if (
  //     homeData &&
  //     homeData?.blocks?.objects?.short &&
  //     homeData?.blocks?.objects?.number
  //   ) {
  //     formik.setFieldValue(
  //       'contractName',
  //       `${homeData?.blocks?.objects?.short} - ${homeData?.blocks?.objects?.number}`,
  //       true,
  //     );
  //     setSelectedCurrency(homeData?.isvalute || '0');
  //   }
  // }, [homeData]);

  useEffect(() => {
    if (calculations) {
      formik.setFieldValue('startPrice', calculations?.startPrice, true);
      formik.setFieldValue('lastPayment', calculations?.lastPayment);
      formik.setFieldValue(
        'left',
        calculations?.sellPrice - calculations?.startPrice,
        true,
      );
      formik.setFieldValue('discount', calculations?.discount, true);
      formik.setFieldValue(
        'discountPercentage',
        calculations?.discountPercentage,
        true,
      );

      formik.setFieldValue('month', parseInt(calculations?.month), true);
    } else if (homeData && !calculations) {
      const pricedefault =
        REPAIR_TYPE.REPAIRED.code == homeData?.isrepaired
          ? homeData?.repaired
          : homeData?.norepaired;
      if (homeData?.terassa) {
        const terracePriceDefault =
          homeData?.isrepaired == 1
            ? homeData?.terassa_price_repaired
            : homeData?.terassa_price;
        const startpricedefault = parseInt(
          ((homeData?.square * homeData?.start +
            +terracePriceDefault * +homeData?.terassa) *
            pricedefault) /
            100,
        );
        formik.setFieldValue('startPrice', startpricedefault, true);

        formik.setFieldValue(
          'left',
          homeData?.square * homeData?.start +
            +terracePriceDefault * +homeData?.terassa -
            startpricedefault,
          true,
        );
      } else {
        const startpricedefault = parseInt(
          (homeData?.square * homeData?.start * pricedefault) / 100,
        );
        formik.setFieldValue('startPrice', startpricedefault, true);

        formik.setFieldValue(
          'left',
          homeData?.square * pricedefault - startpricedefault,
          true,
        );
      }

      formik.setFieldValue('month', parseInt(homeData?.blocks.month), true);
    }
  }, [homeData, calculations]);

  const onChangeDiscount = useCallback(
    (event) => {
      const formattedValue =
        event.target.value &&
        parseFloat(event.target.value.split(' ').join(''));
      formik.setFieldValue('discount', formattedValue, true);
      formik.setFieldValue(
        'discountPercentage',
        (formattedValue / formik.values.sum) * 100,
        true,
      );
      formik.setFieldValue(
        'left',
        formik.values.sum - formik.values.startPrice - formattedValue,
        true,
      );
    },
    [formik.values.sum, formik.values.startPrice],
  );

  const onChangeDiscountPercentage = useCallback(
    (event) => {
      let formattedValue =
        event.target.value &&
        parseFloat(event.target.value.split(' ').join(''));
      formik.setFieldValue('discountPercentage', formattedValue, true);
      formik.setFieldValue(
        'discount',
        (formattedValue / 100) * formik.values.sum,
        true,
      );
      formik.setFieldValue(
        'left',
        formik.values.sum -
          formik.values.startPrice -
          (formattedValue / 100) * formik.values.sum,
        true,
      );
    },
    [formik.values.sum, formik.values.startPrice],
  );

  useEffect(() => {
    const { id } = user?.user;
    if (
      staffList?.find((operator) => operator?.id == id)?.id &&
      !formik.values.operator_id
    ) {
      formik.setFieldValue('operator_id', id, true);
    }
  }, [staffList]);

  const originalPriceForSquare = useMemo(() => {
    const price = parseFloat(
      homeData?.isvalute == '1'
        ? selectedCurrency == '1'
          ? homeData?.[repairedType]
          : homeData?.[repairedType] * currencyData.sum
        : selectedCurrency == '0'
          ? homeData?.[repairedType]
          : homeData?.[repairedType] / currencyData.sum,
    );
    return price;
  }, [homeData, selectedCurrency, repairedType, currencyData.sum]);

  const originalTerracePriceForSquare = useMemo(() => {
    const rep =
      repairedType == 'norepaired' ? 'terassa_price' : 'terassa_price_repaired';
    const price = parseFloat(
      homeData?.isvalute == '1'
        ? selectedCurrency == '1'
          ? homeData?.[rep]
          : homeData?.[rep] * currencyData.sum
        : selectedCurrency == '0'
          ? homeData?.[rep]
          : homeData?.[rep] / currencyData.sum,
    );
    return price;
  }, [homeData, selectedCurrency, repairedType, currencyData.sum]);

  const sellPrice = useMemo(() => {
    const price = parseFloat(formik.values.sum - formik.values.discount);
    return price;
  }, [formik.values.sum, formik.values.discount]);

  const sellInnerPrice = useMemo(() => {
    const price = parseFloat(
      formik.values.sum - formik.values.terraceSum - formik.values.discount,
    );
    return price;
  }, [formik.values.sum, formik.values.discount, formik.values.terraceSum]);

  const sellPriceTerrace = useMemo(() => {
    const price = parseFloat(
      formik.values.sum - formik.values.discount - formik.values.innerSum,
    );
    return price;
  }, [formik.values.sum, formik.values.discount, formik.values.innerSum]);

  const sellPriceForSquare = useMemo(() => {
    const price = parseFloat(sellPrice / homeData?.square);
    return price;
  }, [sellPrice, homeData?.square]);

  const sellPriceInnerForSquare = useMemo(() => {
    const price = parseFloat(sellInnerPrice / homeData?.square);
    return price;
  }, [sellPrice, homeData?.square]);

  const sellPriceTerraceForSquare = useMemo(() => {
    const price = parseFloat(sellPriceTerrace / +homeData?.terassa);
    return price;
  }, [sellPriceTerrace, homeData?.terassa]);

  useEffect(() => {
    const staff =
      staffList?.find((staff) => staff?.id == formik.values.operator_id)
        ?.name || '';
    formik.setFieldValue('operator_name', staff);
  }, [staffList, formik.values.operator_id]);

  const onChangePriceForSquare = useCallback(
    (e) => {
      const formattedValue =
        e?.target?.value && parseFloat(e.target.value.split(' ').join(''));
      formik.setFieldValue('price', formattedValue, true);
      if (repairData?.square) {
        formik.setFieldValue(
          'sum',
          formatMultiplies([formattedValue, repairData?.square], 2),
        );
        formik.setFieldValue(
          'left',
          formatMultiplies([formattedValue, repairData?.square], 2) -
            formik.values.startPrice -
            formik.values.discount,
        );
        formik.setFieldValue(
          'discountPercentage',
          parseInt(
            (formik.values.discount * 100) /
              formatMultiplies([formattedValue, repairData?.square], 2),
          ),
        );
      }
    },
    [repairData?.square, formik.values.startPrice, formik.values.discount],
  );
  const onChangeInnerPriceForSquare = useCallback(
    (e) => {
      const formattedValue =
        e?.target?.value && parseFloat(e.target.value.split(' ').join(''));
      formik.setFieldValue('price', formattedValue, true);
      if (repairData?.square) {
        formik.setFieldValue(
          'innerSum',
          formatMultiplies([formattedValue, repairData?.square], 2),
        );
        formik.setFieldValue(
          'sum',
          formatMultiplies([formattedValue, repairData?.square], 2) +
            formik.values.terraceSum,
        );
        formik.setFieldValue(
          'left',
          formatMultiplies([formattedValue, repairData?.square], 2) +
            formik.values.terraceSum -
            formik.values.startPrice -
            formik.values.discount,
        );
        formik.setFieldValue(
          'discountPercentage',
          parseInt(
            (formik.values.discount * 100) /
              (formatMultiplies([formattedValue, repairData?.square], 2) +
                formik.values.terraceSum),
          ),
        );
      }
    },
    [
      repairData?.square,
      formik.values.startPrice,
      formik.values.discount,
      formik.values.terraceSum,
    ],
  );
  const onChangeTerracePriceForSquare = useCallback(
    (e) => {
      const formattedValue =
        e?.target?.value && parseFloat(e.target.value.split(' ').join(''));
      formik.setFieldValue('terracePrice', formattedValue, true);
      if (homeData?.terassa) {
        formik.setFieldValue(
          'terraceSum',
          formatMultiplies([formattedValue, +homeData?.terassa], 2),
        );
        formik.setFieldValue(
          'sum',
          formatMultiplies([formattedValue, +homeData?.terassa], 2) +
            formik.values.innerSum,
        );
        formik.setFieldValue(
          'left',
          formatMultiplies([formattedValue, +homeData?.terassa], 2) +
            formik.values.innerSum -
            formik.values.startPrice -
            formik.values.discount,
        );
        formik.setFieldValue(
          'discountPercentage',
          parseInt(
            (formik.values.discount * 100) /
              (formatMultiplies([formattedValue, +homeData?.terassa], 2) +
                formik.values.innerSum),
          ),
        );
      }
    },
    [
      homeData?.terassa,
      formik.values.startPrice,
      formik.values.discount,
      formik.values.innerSum,
    ],
  );

  const onChangeSum = useCallback((e) => {
    const formattedValue =
      e.target.value && parseFloat(e.target.value.split(' ').join(''));
    formik.setFieldValue('sum', formattedValue, true);
  }, []);

  const onChangeTerraceSum = useCallback((e) => {
    const formattedValue =
      e.target.value && parseFloat(e.target.value.split(' ').join(''));
    formik.setFieldValue('terraceSum', formattedValue, true);
  }, []);
  const onChangeInnerSum = useCallback((e) => {
    const formattedValue =
      e.target.value && parseFloat(e.target.value.split(' ').join(''));
    formik.setFieldValue('innerSum', formattedValue, true);
  }, []);

  const onBlurTerraceSum = useCallback(() => {
    formik.setFieldValue(
      'sum',
      formik.values.innerSum + formik?.values?.terraceSum,
      true,
    );
    formik.setFieldValue(
      'left',
      formik.values.innerSum +
        formik?.values?.terraceSum -
        formik?.values?.discount -
        formik.values.startPrice,
      true,
    );
    formik.setFieldValue(
      'discountPercentage',
      (formik?.values?.discount /
        (formik.values.innerSum + formik?.values?.terraceSum)) *
        100,
      true,
    );
  }, [
    formik.values.sum,
    formik.values.startPrice,
    formik?.values?.discount,
    formik.values.innerSum,
    formik?.values?.terraceSum,
  ]);

  const onBlurSum = useCallback(() => {
    if (homeData?.terassa) {
      formik.setFieldValue(
        'innerSum',
        formik.values.sum - formik.values.terraceSum,
        true,
      );
      formik.setFieldValue(
        'left',
        formik.values.sum - formik?.values?.discount - formik.values.startPrice,
        true,
      );
      formik.setFieldValue(
        'discountPercentage',
        (formik?.values?.discount / formik.values.sum) * 100,
        true,
      );
    } else {
      formik.setFieldValue(
        'left',
        formik.values.sum - formik?.values?.discount - formik.values.startPrice,
        true,
      );
      formik.setFieldValue(
        'discountPercentage',
        (formik?.values?.discount / formik.values.sum) * 100,
        true,
      );
    }
  }, [
    formik.values.sum,
    formik.values.startPrice,
    formik?.values?.discount,
    formik?.values?.innerSum,
  ]);

  const onBlurInnerSum = useCallback(() => {
    formik.setFieldValue(
      'sum',
      formik.values.innerSum + formik?.values?.terraceSum,
      true,
    );
    formik.setFieldValue(
      'left',
      formik.values.innerSum +
        formik?.values?.terraceSum -
        formik?.values?.discount -
        formik.values.startPrice,
      true,
    );
    formik.setFieldValue(
      'discountPercentage',
      (formik?.values?.discount /
        (formik.values.innerSum + formik?.values?.terraceSum)) *
        100,
      true,
    );
  }, [
    formik.values.sum,
    formik.values.startPrice,
    formik?.values?.discount,
    formik?.values?.terraceSum,
    formik.values.innerSum,
  ]);

  const onChangeStartPrice = useCallback(
    (e) => {
      const formattedValue =
        e.target.value && parseFloat(e.target.value.split(' ').join(''));
      formik.setFieldValue('startPrice', formattedValue, true);
      formik.setFieldValue(
        'left',
        formik.values.sum - formattedValue - formik.values.discount,
        true,
      );
    },
    [formik.values.sum, formik.values.discount],
  );
  const onChangeMonth = useCallback((e) => {
    formik.setFieldValue(
      'month',
      e.target.value ? parseFloat(e.target.value) : '',
      true,
    );
  }, []);

  const onChangeInterval = useCallback((e) => {
    formik.setFieldValue(
      'interval',
      e.target.value ? parseFloat(e.target.value) : '',
      true,
    );
  }, []);

  const onChangeStartDate = useCallback((newValue) => {
    if (newValue && newValue._isValid && newValue > moment('2000-1-1')) {
      formik.setFieldValue(
        'startDate',
        moment(newValue).format('YYYY-MM-DD'),
        true,
      );
    } else {
      formik.setFieldValue('startDate', '', true);
    }
  }, []);

  const onChangeDate = useCallback((newValue) => {
    if (newValue && newValue._isValid && newValue > moment('2000-1-1')) {
      formik.setFieldValue('date', moment(newValue).format('YYYY-MM-DD'), true);
    } else {
      formik.setFieldValue('date', '', true);
    }
  }, []);

  const onChangeStaff = useCallback((e, v) => {
    const { id, name } = v;
    formik.setFieldValue('operator_name', name ? name : '', true);
    formik.setFieldValue('operator_id', id ? id : '', true);
  }, []);

  const onChangeContractNumber = useCallback((event) => {
    formik.setFieldValue('contractName', event.target.value, true);
  }, []);

  return (
    <motion.div
      variants={stepperItem({
        direction: direction,
        duration: 0,
      })}
      initial='hidden'
      animate={appear ? 'show' : 'hidden'}
    >
      <div className='component-add-wrapper'>
        <div className='component-add-body overflow-y-auto h-full'>
          <div className='home-repair-type'>
            <div className='title'>{t('contract.step.three.title')}</div>
            <div className='repair-types'>
              <ButtonBase
                className='repair-type repair-type-non-repaired'
                id='norepaired'
                onClick={() =>
                  handleRepairType('norepaired', {
                    price: homeData?.norepaired,
                    square: homeData?.square,
                    isvalute: homeData?.isvalute,
                    terracePrice: homeData?.terassa_price,
                  })
                }
              >
                <div className='flex items-center justify-between w-full'>
                  <span>
                    {t('contract.step.three.repairType.notRepaired')}:
                  </span>
                  <span>
                    <CurrencyFormat
                      value={homeData?.norepaired}
                      suffix={homeData?.isvalute == '1' ? ' $' : ' UZS'}
                    />
                  </span>
                </div>
                {currencyData &&
                  currencyData.sum &&
                  homeData?.isvalute == '1' && (
                    <div className='price-by-currency-wrapper'>
                      =
                      <CurrencyFormat
                        value={formatMultiplies(
                          [currencyData.sum, homeData?.norepaired],
                          2,
                        )}
                        className='ml-1'
                      />
                    </div>
                  )}
                <div className='flex items-center justify-between w-full mt-2'>
                  <span>
                    {homeData?.square}{' '}
                    <Trans i18nKey='common.global.meter'>
                      m<sup>2</sup>
                    </Trans>
                  </span>
                  <span>
                    {homeData?.square && homeData?.norepaired && (
                      <CurrencyFormat
                        value={formatMultiplies(
                          [homeData?.square, homeData?.norepaired],
                          2,
                        )}
                        suffix={homeData?.isvalute == '1' ? ' $' : ' UZS'}
                      />
                    )}
                  </span>
                </div>
                {currencyData &&
                  currencyData.sum &&
                  homeData?.isvalute == '1' && (
                    <div className='price-by-currency-wrapper'>
                      =
                      <CurrencyFormat
                        value={formatMultiplies(
                          [
                            currencyData.sum,
                            parseFloat(homeData?.square * homeData?.norepaired),
                          ],
                          2,
                        )}
                        className='ml-1'
                      />
                    </div>
                  )}
              </ButtonBase>
              <ButtonBase
                className='repair-type repair-type-repaired !mx-4'
                id='repaired'
                onClick={() =>
                  handleRepairType('repaired', {
                    price: homeData?.repaired,
                    square: homeData?.square,
                    isvalute: homeData?.isvalute,
                    terracePrice: homeData?.terassa_price_repaired,
                  })
                }
              >
                <div className='flex items-center justify-between w-full'>
                  <span>{t('contract.step.three.repairType.repaired')}:</span>
                  <span>
                    <CurrencyFormat
                      value={homeData?.repaired}
                      suffix={homeData?.isvalute == '1' ? ' $' : ' UZS'}
                    />
                  </span>
                </div>
                {currencyData &&
                  currencyData.sum &&
                  homeData?.isvalute == '1' && (
                    <div className='price-by-currency-wrapper'>
                      =
                      <CurrencyFormat
                        value={formatMultiplies(
                          [currencyData.sum, homeData?.repaired],
                          2,
                        )}
                        className='ml-1'
                      />
                    </div>
                  )}
                <div className='flex items-center justify-between w-full mt-2'>
                  <span>
                    {homeData?.square}{' '}
                    <Trans i18nKey='common.global.meter'>
                      m<sup>2</sup>
                    </Trans>
                  </span>
                  <span>
                    {homeData?.square && homeData?.repaired && (
                      <CurrencyFormat
                        value={formatMultiplies(
                          [homeData?.square, homeData?.repaired],
                          2,
                        )}
                        suffix={homeData?.isvalute == '1' ? ' $' : ' UZS'}
                      />
                    )}
                  </span>
                </div>
                {currencyData &&
                  currencyData.sum &&
                  homeData?.isvalute == '1' && (
                    <div className='price-by-currency-wrapper'>
                      =
                      <CurrencyFormat
                        value={formatMultiplies(
                          [
                            currencyData.sum,
                            parseFloat(homeData?.square * homeData?.repaired),
                          ],
                          2,
                        )}
                        className='ml-1'
                      />
                    </div>
                  )}
              </ButtonBase>
              <ButtonBase
                className='repair-type repair-type-deal-price'
                id='deal_price'
                onClick={() =>
                  handleRepairType('deal_price', {
                    price: homeData?.deal_price,
                    square: homeData?.square,
                    isvalute: homeData?.isvalute,
                    terracePrice: homeData?.terassa_price_repaired,
                  })
                }
              >
                <div className='flex items-center justify-between w-full'>
                  <span>
                    <Trans i18nKey='contract.step.three.repairType.dealPrice'>
                      Kelishilgan narxi(1 m<sup>2</sup>)
                    </Trans>
                    :
                  </span>
                  <span>
                    <CurrencyFormat
                      value={homeData?.deal_price}
                      suffix={homeData?.isvalute == '1' ? ' $' : ' UZS'}
                    />
                  </span>
                </div>
                {currencyData &&
                  currencyData.sum &&
                  homeData?.isvalute == '1' && (
                    <div className='price-by-currency-wrapper'>
                      =
                      <CurrencyFormat
                        value={formatMultiplies(
                          [currencyData.sum, homeData?.deal_price],
                          2,
                        )}
                        className='ml-1'
                      />
                    </div>
                  )}
                <div className='flex items-center justify-between w-full mt-2'>
                  <span>
                    {homeData?.square}{' '}
                    <Trans i18nKey='common.global.meter'>
                      m<sup>2</sup>
                    </Trans>
                  </span>
                  <span>
                    {homeData?.square && homeData?.deal_price && (
                      <CurrencyFormat
                        value={formatMultiplies(
                          [homeData?.square, homeData?.deal_price],
                          2,
                        )}
                        suffix={homeData?.isvalute == '1' ? ' $' : ' UZS'}
                      />
                    )}
                  </span>
                </div>
                {currencyData &&
                  currencyData.sum &&
                  homeData?.isvalute == '1' && (
                    <div className='price-by-currency-wrapper'>
                      =
                      <CurrencyFormat
                        value={formatMultiplies(
                          [
                            currencyData.sum,
                            parseFloat(homeData?.square * homeData?.deal_price),
                          ],
                          2,
                        )}
                        className='ml-1'
                      />
                    </div>
                  )}
              </ButtonBase>
            </div>
            <div className='flex justify-center mt-4 h-14'>
              <ToggleButtonGroup
                color='primary'
                value={selectedCurrency?.toString()}
                exclusive
                onChange={(event) => {
                  if (selectedCurrency?.toString() != event.target.value)
                    handleCurrencyChange(event.target.value);
                }}
                aria-label='currency'
              >
                <ToggleButton color='primary' value='0'>
                  UZS
                </ToggleButton>
                <ToggleButton color='primary' value='1'>
                  USD
                </ToggleButton>
              </ToggleButtonGroup>
            </div>
          </div>

          <div className='home-payment-wrapper mt-3'>
            <div className='home-payment-details'>
              <div className='flex flex-row justify-between'>
                <div className='w-1/2 mx-20'>
                  {calculations?.terassasum ? (
                    <>
                      <div className='w-full rounded-lg border border-gray-300 mb-1 px-2 pt-4 relative'>
                        <span className='absolute bg-[#F2F3F7] -top-0.5 px-0.5 -translate-y-1/2 text-sm text-gray-500'>
                          Ichki maydon
                        </span>
                        <div className='flex gap-2'>
                          <NumericFormat
                            id='price-currency-field'
                            readOnly
                            name='price'
                            label={
                              <Trans i18nKey='contract.step.three.fields.priceForSquare'>
                                1 m<sup>2</sup> asl narxi
                              </Trans>
                            }
                            value={originalPriceForSquare}
                            error={
                              formik.touched.price &&
                              Boolean(formik.errors.price)
                            }
                            helperText={
                              formik.touched.price && (
                                <Trans i18nKey={formik.errors.price}>
                                  1 m<sup>2</sup> narxini kiritish majburiy!
                                </Trans>
                              )
                            }
                            onChange={onChangeInnerPriceForSquare}
                            component={motion.div}
                            variants={fadeUp(30, 'tween', 0.1, 0.5)}
                            initial='hidden'
                            animate='show'
                            viewport={{ once: true, amount: 0.25 }}
                            color='formColor'
                            variant='outlined'
                            fullWidth
                            customInput={TextField}
                            inputProps={{ readOnly: false }}
                            allowNegative={false}
                            thousandSeparator={' '}
                            decimalScale={1}
                          />
                          <NumericFormat
                            id='price-currency-field'
                            name='price'
                            label={
                              <Trans i18nKey='contract.step.three.sellForSquarePrice'>
                                Sotuv 1 m<sup>2</sup> narxi
                              </Trans>
                            }
                            value={sellPriceInnerForSquare}
                            error={
                              formik.touched.price &&
                              Boolean(formik.errors.price)
                            }
                            helperText={
                              formik.touched.price && (
                                <Trans i18nKey={formik.errors.price}>
                                  1 m<sup>2</sup> narxini kiritish majburiy!
                                </Trans>
                              )
                            }
                            component={motion.div}
                            variants={fadeUp(30, 'tween', 0.1, 0.5)}
                            initial='hidden'
                            animate='show'
                            viewport={{ once: true, amount: 0.25 }}
                            color='formColor'
                            variant='outlined'
                            fullWidth
                            customInput={TextField}
                            inputProps={{ readOnly: true }}
                            allowNegative={false}
                            thousandSeparator={' '}
                            decimalScale={1}
                          />
                        </div>
                        <div className='grid grid-cols-2 gap-2'>
                          {selectedCurrency == '1' &&
                            !isNaN(originalPriceForSquare) && (
                              <CurrencySubContent
                                value={originalPriceForSquare}
                              />
                            )}
                          {selectedCurrency == '1' &&
                            !isNaN(formik.values.price) && (
                              <CurrencySubContent value={formik.values.price} />
                            )}
                        </div>
                        <div className='flex gap-2'>
                          <NumericFormat
                            id='sum-currency-field'
                            name='innerSum'
                            label={t('common.fields.contractSum')}
                            value={formik.values.innerSum}
                            onChange={onChangeInnerSum}
                            onBlur={onBlurInnerSum}
                            error={
                              formik.touched.sum && Boolean(formik.errors.sum)
                            }
                            helperText={
                              formik.touched.sum && t(formik.errors.sum)
                            }
                            component={motion.div}
                            variants={fadeUp(30, 'tween', 0.1, 0.5)}
                            initial='hidden'
                            animate='show'
                            viewport={{ once: true, amount: 0.25 }}
                            color='formColor'
                            variant='outlined'
                            fullWidth
                            customInput={TextField}
                            allowNegative={false}
                            thousandSeparator={' '}
                            decimalScale={1}
                          />
                          <NumericFormat
                            id='sum-currency-field'
                            name='innerSum'
                            label={t('shaxmatka.homeDetail.sellPrice')}
                            value={sellInnerPrice}
                            error={
                              formik.touched.innerSum &&
                              Boolean(formik.errors.innerSum)
                            }
                            helperText={
                              formik.touched.innerSum &&
                              t(formik.errors.innerSum)
                            }
                            component={motion.div}
                            variants={fadeUp(30, 'tween', 0.1, 0.5)}
                            initial='hidden'
                            animate='show'
                            viewport={{ once: true, amount: 0.25 }}
                            color='formColor'
                            variant='outlined'
                            fullWidth
                            customInput={TextField}
                            allowNegative={false}
                            thousandSeparator={' '}
                            decimalScale={1}
                            inputProps={{
                              readOnly: true,
                            }}
                          />
                        </div>
                        <div className='grid grid-cols-2 gap-2'>
                          {selectedCurrency == '1' &&
                            !isNaN(formik.values.sum) && (
                              <CurrencySubContent value={formik.values.sum} />
                            )}
                          {selectedCurrency == '1' && !isNaN(sellPrice) && (
                            <CurrencySubContent value={sellPrice} />
                          )}
                        </div>
                      </div>
                      <div className='flex gap-2'>
                        <NumericFormat
                          id='sum-currency-field'
                          name='sum'
                          label={t('common.fields.contractSum')}
                          value={formik.values.sum}
                          onChange={onChangeSum}
                          onBlur={onBlurSum}
                          error={
                            formik.touched.sum && Boolean(formik.errors.sum)
                          }
                          helperText={
                            formik.touched.sum && t(formik.errors.sum)
                          }
                          component={motion.div}
                          variants={fadeUp(30, 'tween', 0.1, 0.5)}
                          initial='hidden'
                          animate='show'
                          viewport={{ once: true, amount: 0.25 }}
                          color='formColor'
                          variant='outlined'
                          fullWidth
                          customInput={TextField}
                          allowNegative={false}
                          thousandSeparator={' '}
                          decimalScale={1}
                        />
                        <NumericFormat
                          id='sum-currency-field'
                          name='sum'
                          label={t('shaxmatka.homeDetail.sellPrice')}
                          value={sellPrice}
                          error={
                            formik.touched.sum && Boolean(formik.errors.sum)
                          }
                          helperText={
                            formik.touched.sum && t(formik.errors.sum)
                          }
                          component={motion.div}
                          variants={fadeUp(30, 'tween', 0.1, 0.5)}
                          initial='hidden'
                          animate='show'
                          viewport={{ once: true, amount: 0.25 }}
                          color='formColor'
                          variant='outlined'
                          fullWidth
                          customInput={TextField}
                          allowNegative={false}
                          thousandSeparator={' '}
                          decimalScale={1}
                          inputProps={{
                            readOnly: true,
                          }}
                        />
                      </div>
                      <div className='grid grid-cols-2 gap-2'>
                        {selectedCurrency == '1' &&
                          !isNaN(formik.values.sum) && (
                            <CurrencySubContent value={formik.values.sum} />
                          )}
                        {selectedCurrency == '1' && !isNaN(sellPrice) && (
                          <CurrencySubContent value={sellPrice} />
                        )}
                      </div>
                    </>
                  ) : (
                    <>
                      <div className='flex gap-2'>
                        <NumericFormat
                          id='price-currency-field'
                          readOnly
                          name='price'
                          label={
                            <Trans i18nKey='contract.step.three.fields.priceForSquare'>
                              1 m<sup>2</sup> asl narxi
                            </Trans>
                          }
                          value={originalPriceForSquare}
                          error={
                            formik.touched.price && Boolean(formik.errors.price)
                          }
                          helperText={
                            formik.touched.price && (
                              <Trans i18nKey={formik.errors.price}>
                                1 m<sup>2</sup> narxini kiritish majburiy!
                              </Trans>
                            )
                          }
                          onChange={onChangePriceForSquare}
                          component={motion.div}
                          variants={fadeUp(30, 'tween', 0.1, 0.5)}
                          initial='hidden'
                          animate='show'
                          viewport={{ once: true, amount: 0.25 }}
                          color='formColor'
                          variant='outlined'
                          fullWidth
                          customInput={TextField}
                          inputProps={{ readOnly: false }}
                          allowNegative={false}
                          thousandSeparator={' '}
                          decimalScale={1}
                        />
                        <NumericFormat
                          id='price-currency-field'
                          name='price'
                          label={
                            <Trans i18nKey='contract.step.three.sellForSquarePrice'>
                              Sotuv 1 m<sup>2</sup> narxi
                            </Trans>
                          }
                          value={sellPriceForSquare}
                          error={
                            formik.touched.price && Boolean(formik.errors.price)
                          }
                          helperText={
                            formik.touched.price && (
                              <Trans i18nKey={formik.errors.price}>
                                1 m<sup>2</sup> narxini kiritish majburiy!
                              </Trans>
                            )
                          }
                          component={motion.div}
                          variants={fadeUp(30, 'tween', 0.1, 0.5)}
                          initial='hidden'
                          animate='show'
                          viewport={{ once: true, amount: 0.25 }}
                          color='formColor'
                          variant='outlined'
                          fullWidth
                          customInput={TextField}
                          inputProps={{ readOnly: true }}
                          allowNegative={false}
                          thousandSeparator={' '}
                          decimalScale={1}
                        />
                      </div>
                      <div className='grid grid-cols-2 gap-2'>
                        {selectedCurrency == '1' &&
                          !isNaN(originalPriceForSquare) && (
                            <CurrencySubContent
                              value={originalPriceForSquare}
                            />
                          )}
                        {selectedCurrency == '1' &&
                          !isNaN(formik.values.price) && (
                            <CurrencySubContent value={formik.values.price} />
                          )}
                      </div>
                      <div className='flex gap-2'>
                        <NumericFormat
                          id='sum-currency-field'
                          name='sum'
                          label={t('common.fields.contractSum')}
                          value={formik.values.sum}
                          onChange={onChangeSum}
                          onBlur={onBlurSum}
                          error={
                            formik.touched.sum && Boolean(formik.errors.sum)
                          }
                          helperText={
                            formik.touched.sum && t(formik.errors.sum)
                          }
                          component={motion.div}
                          variants={fadeUp(30, 'tween', 0.1, 0.5)}
                          initial='hidden'
                          animate='show'
                          viewport={{ once: true, amount: 0.25 }}
                          color='formColor'
                          variant='outlined'
                          fullWidth
                          customInput={TextField}
                          allowNegative={false}
                          thousandSeparator={' '}
                          decimalScale={1}
                        />
                        <NumericFormat
                          id='sum-currency-field'
                          name='sum'
                          label={t('shaxmatka.homeDetail.sellPrice')}
                          value={sellPrice}
                          error={
                            formik.touched.sum && Boolean(formik.errors.sum)
                          }
                          helperText={
                            formik.touched.sum && t(formik.errors.sum)
                          }
                          component={motion.div}
                          variants={fadeUp(30, 'tween', 0.1, 0.5)}
                          initial='hidden'
                          animate='show'
                          viewport={{ once: true, amount: 0.25 }}
                          color='formColor'
                          variant='outlined'
                          fullWidth
                          customInput={TextField}
                          allowNegative={false}
                          thousandSeparator={' '}
                          decimalScale={1}
                          inputProps={{
                            readOnly: true,
                          }}
                        />
                      </div>
                      <div className='grid grid-cols-2 gap-2'>
                        {selectedCurrency == '1' &&
                          !isNaN(formik.values.sum) && (
                            <CurrencySubContent value={formik.values.sum} />
                          )}
                        {selectedCurrency == '1' && !isNaN(sellPrice) && (
                          <CurrencySubContent value={sellPrice} />
                        )}
                      </div>
                    </>
                  )}

                  <NumericFormat
                    id='start-price-currency-field'
                    name='start-price'
                    label={t('common.fields.startPriceAmount')}
                    value={formik.values.startPrice}
                    onChange={onChangeStartPrice}
                    error={
                      formik.touched.startPrice &&
                      Boolean(formik.errors.startPrice)
                    }
                    helperText={
                      formik.touched.startPrice && t(formik.errors.startPrice)
                    }
                    component={motion.div}
                    variants={fadeUp(30, 'tween', 0.2, 0.5)}
                    initial='hidden'
                    animate='show'
                    isAllowed={({ floatValue }) => {
                      if (floatValue <= +formik.values.sum) return true;
                    }}
                    viewport={{ once: true, amount: 0.25 }}
                    color='formColor'
                    variant='outlined'
                    fullWidth
                    customInput={TextField}
                    allowNegative={false}
                    thousandSeparator={' '}
                    decimalScale={1}
                  />
                  {selectedCurrency == '1' &&
                    !isNaN(formik.values.startPrice) && (
                      <CurrencySubContent value={formik.values.startPrice} />
                    )}

                  <NumericFormat
                    id='left-currency-field'
                    name='left'
                    label={t('common.fields.leftSum')}
                    value={formik.values.left}
                    error={formik.touched.left && Boolean(formik.errors.left)}
                    helperText={formik.touched.left && t(formik.errors.left)}
                    component={motion.div}
                    variants={fadeUp(30, 'tween', 0.3, 0.5)}
                    initial='hidden'
                    animate='show'
                    viewport={{ once: true, amount: 0.25 }}
                    color='formColor'
                    variant='outlined'
                    fullWidth
                    customInput={TextField}
                    allowNegative={false}
                    thousandSeparator={' '}
                    decimalScale={1}
                    inputProps={{
                      readOnly: true,
                    }}
                  />
                  {selectedCurrency == '1' && !isNaN(formik.values.left) && (
                    <CurrencySubContent value={formik.values.left} />
                  )}

                  <NumericFormat
                    id='month'
                    name='month'
                    label={t('common.fields.loanRepayment')}
                    value={formik.values.month}
                    onChange={onChangeMonth}
                    error={formik.touched.month && Boolean(formik.errors.month)}
                    helperText={formik.touched.month && t(formik.errors.month)}
                    component={motion.div}
                    variants={fadeUp(30, 'tween', 0.4, 0.5)}
                    initial='hidden'
                    animate='show'
                    viewport={{ once: true, amount: 0.25 }}
                    color='formColor'
                    variant='outlined'
                    fullWidth
                    customInput={TextField}
                    allowNegative={false}
                    decimalScale={0}
                  />

                  <NumericFormat
                    id='interval'
                    name='interval'
                    label={t('common.fields.interval')}
                    value={formik.values.interval}
                    onChange={onChangeInterval}
                    error={
                      formik.touched.interval && Boolean(formik.errors.interval)
                    }
                    helperText={
                      formik.touched.interval && t(formik.errors.interval)
                    }
                    component={motion.div}
                    variants={fadeUp(30, 'tween', 0.5, 0.5)}
                    initial='hidden'
                    animate='show'
                    viewport={{ once: true, amount: 0.25 }}
                    color='formColor'
                    variant='outlined'
                    fullWidth
                    customInput={TextField}
                    allowNegative={false}
                    decimalScale={0}
                  />

                  <Autocomplete
                    id='staff-autocomplete'
                    options={staffList || []}
                    disableClearable
                    fullWidth
                    loading={isLoading || isFetching}
                    noOptionsText={t('common.global.noDataFound')}
                    value={formik.values.operator_id}
                    inputValue={formik?.values?.operator_name}
                    onInputChange={(event, newInputValue) => {
                      if (event?.type == 'change')
                        formik.setFieldValue('operator_name', newInputValue);
                    }}
                    getOptionLabel={(option) =>
                      option.name ? option.name : ''
                    }
                    onChange={onChangeStaff}
                    loadingText={
                      <div className='circular-progress-box'>
                        <CircularProgress size={25} />
                      </div>
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        color='formColor'
                        variant='outlined'
                        component={motion.div}
                        variants={fadeUp(30, 'tween', 0.6, 0.5)}
                        initial='hidden'
                        animate='show'
                        viewport={{ once: true, amount: 0.25 }}
                        label={t('common.fields.intermediary')}
                        error={
                          formik.touched.operator_id &&
                          Boolean(formik.errors.operator_id)
                        }
                        helperText={
                          formik.touched.operator_id &&
                          t(formik.errors.operator_id)
                        }
                        autoComplete='off'
                      />
                    )}
                  />
                </div>

                <div className='w-1/2 mx-20'>
                  {!!calculations?.terassasum && (
                    <div className='w-full rounded-lg border border-gray-300 mb-1 px-2 pt-4 relative'>
                      <span className='absolute bg-[#F2F3F7] -top-0.5 px-0.5 -translate-y-1/2 text-sm text-gray-500'>
                        Terassa maydon
                      </span>
                      <div className='flex gap-2'>
                        <NumericFormat
                          id='price-currency-field'
                          name='terracePrice'
                          label={
                            <Trans i18nKey='contract.step.three.fields.priceForSquare'>
                              1 m<sup>2</sup> asl narxi
                            </Trans>
                          }
                          value={originalTerracePriceForSquare}
                          error={
                            formik.touched.terracePrice &&
                            Boolean(formik.errors.terracePrice)
                          }
                          helperText={
                            formik.touched.price && (
                              <Trans i18nKey={formik.errors.price}>
                                1 m<sup>2</sup> narxini kiritish majburiy!
                              </Trans>
                            )
                          }
                          onChange={onChangeTerracePriceForSquare}
                          component={motion.div}
                          variants={fadeUp(30, 'tween', 0.1, 0.5)}
                          initial='hidden'
                          animate='show'
                          viewport={{ once: true, amount: 0.25 }}
                          color='formColor'
                          variant='outlined'
                          fullWidth
                          customInput={TextField}
                          inputProps={{ readOnly: false }}
                          allowNegative={false}
                          thousandSeparator={' '}
                          decimalScale={1}
                        />
                        <NumericFormat
                          id='price-currency-field'
                          name='price'
                          label={
                            <Trans i18nKey='contract.step.three.sellForSquarePrice'>
                              Sotuv 1 m<sup>2</sup> narxi
                            </Trans>
                          }
                          value={sellPriceTerraceForSquare}
                          error={
                            formik.touched.price && Boolean(formik.errors.price)
                          }
                          helperText={
                            formik.touched.price && (
                              <Trans i18nKey={formik.errors.price}>
                                1 m<sup>2</sup> narxini kiritish majburiy!
                              </Trans>
                            )
                          }
                          component={motion.div}
                          variants={fadeUp(30, 'tween', 0.1, 0.5)}
                          initial='hidden'
                          animate='show'
                          viewport={{ once: true, amount: 0.25 }}
                          color='formColor'
                          variant='outlined'
                          fullWidth
                          customInput={TextField}
                          inputProps={{ readOnly: true }}
                          allowNegative={false}
                          thousandSeparator={' '}
                          decimalScale={1}
                        />
                      </div>
                      <div className='grid grid-cols-2 gap-2'>
                        {selectedCurrency == '1' &&
                          !isNaN(originalPriceForSquare) && (
                            <CurrencySubContent
                              value={originalPriceForSquare}
                            />
                          )}
                        {selectedCurrency == '1' &&
                          !isNaN(formik.values.price) && (
                            <CurrencySubContent value={formik.values.price} />
                          )}
                      </div>
                      <div className='flex gap-2'>
                        <NumericFormat
                          id='sum-currency-field'
                          name='terraceSum'
                          label={t('common.fields.contractSum')}
                          value={formik.values.terraceSum}
                          onChange={onChangeTerraceSum}
                          onBlur={onBlurTerraceSum}
                          error={
                            formik.touched.terraceSum &&
                            Boolean(formik.errors.terraceSum)
                          }
                          helperText={
                            formik.touched.terraceSum &&
                            t(formik.errors.terraceSum)
                          }
                          component={motion.div}
                          variants={fadeUp(30, 'tween', 0.1, 0.5)}
                          initial='hidden'
                          animate='show'
                          viewport={{ once: true, amount: 0.25 }}
                          color='formColor'
                          variant='outlined'
                          fullWidth
                          customInput={TextField}
                          allowNegative={false}
                          thousandSeparator={' '}
                          decimalScale={1}
                        />
                        <NumericFormat
                          id='sum-currency-field'
                          name='terraceSum'
                          label={t('shaxmatka.homeDetail.sellPrice')}
                          value={sellPriceTerrace}
                          error={
                            formik.touched.terraceSum &&
                            Boolean(formik.errors.terraceSum)
                          }
                          helperText={
                            formik.touched.terraceSum &&
                            t(formik.errors.terraceSum)
                          }
                          component={motion.div}
                          variants={fadeUp(30, 'tween', 0.1, 0.5)}
                          initial='hidden'
                          animate='show'
                          viewport={{ once: true, amount: 0.25 }}
                          color='formColor'
                          variant='outlined'
                          fullWidth
                          customInput={TextField}
                          allowNegative={false}
                          thousandSeparator={' '}
                          decimalScale={1}
                          inputProps={{
                            readOnly: true,
                          }}
                        />
                      </div>
                      <div className='grid grid-cols-2 gap-2'>
                        {selectedCurrency == '1' &&
                          !isNaN(formik.values.sum) && (
                            <CurrencySubContent value={formik.values.sum} />
                          )}
                        {selectedCurrency == '1' && !isNaN(sellPrice) && (
                          <CurrencySubContent value={sellPrice} />
                        )}
                      </div>
                    </div>
                  )}
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      id='start-date-picker'
                      openTo='day'
                      value={formik.values.startDate}
                      onChange={onChangeStartDate}
                      views={['year', 'month', 'day']}
                      inputFormat='DD/MM/yyyy'
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          component={motion.div}
                          variants={fadeUp(30, 'tween', 0.5, 0.5)}
                          initial='hidden'
                          animate='show'
                          viewport={{ once: true, amount: 0.25 }}
                          color='formColor'
                          variant='outlined'
                          fullWidth
                          id='start'
                          name='start'
                          label={t('common.fields.startDate')}
                          error={
                            formik.touched.startDate &&
                            Boolean(formik.errors.startDate)
                          }
                          helperText={
                            formik.touched.startDate &&
                            t(formik.errors.startDate)
                          }
                          autoComplete='off'
                        />
                      )}
                    />
                  </LocalizationProvider>

                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      id='date-date-picker'
                      openTo='day'
                      value={formik.values.date}
                      onChange={onChangeDate}
                      views={['year', 'month', 'day']}
                      inputFormat='DD/MM/yyyy'
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          component={motion.div}
                          variants={fadeUp(30, 'tween', 0.5, 0.5)}
                          initial='hidden'
                          animate='show'
                          viewport={{ once: true, amount: 0.25 }}
                          color='formColor'
                          variant='outlined'
                          fullWidth
                          id='date'
                          name='date'
                          label={t('common.fields.firstPriceDate')}
                          error={
                            formik.touched.date && Boolean(formik.errors.date)
                          }
                          helperText={
                            formik.touched.date && t(formik.errors.date)
                          }
                          autoComplete='off'
                        />
                      )}
                    />
                  </LocalizationProvider>
                  <div className='flex gap-2'>
                    <NumericFormat
                      id='discount-currency-field'
                      name='discount'
                      label={t('common.fields.discount')}
                      value={formik.values.discount}
                      onChange={onChangeDiscount}
                      error={
                        formik.touched.discount &&
                        Boolean(formik.errors.discount)
                      }
                      helperText={
                        formik.touched.discount && t(formik.errors.discount)
                      }
                      component={motion.div}
                      variants={fadeUp(30, 'tween', 0.3, 0.5)}
                      initial='hidden'
                      animate='show'
                      viewport={{ once: true, amount: 0.25 }}
                      color='formColor'
                      variant='outlined'
                      fullWidth
                      customInput={TextField}
                      allowNegative={false}
                      thousandSeparator={' '}
                      decimalScale={1}
                    />
                    <NumericFormat
                      id='discount-currency-field'
                      name='discount'
                      label={t('common.fields.discountPercentage')}
                      value={formik.values.discountPercentage}
                      onChange={onChangeDiscountPercentage}
                      error={
                        formik.touched.discountPercentage &&
                        Boolean(formik.errors.discountPercentage)
                      }
                      helperText={
                        formik.touched.discountPercentage &&
                        t(formik.errors.discountPercentage)
                      }
                      component={motion.div}
                      variants={fadeUp(30, 'tween', 0.3, 0.5)}
                      initial='hidden'
                      animate='show'
                      viewport={{ once: true, amount: 0.25 }}
                      color='formColor'
                      variant='outlined'
                      fullWidth
                      customInput={TextField}
                      allowNegative={false}
                      thousandSeparator={' '}
                      decimalScale={1}
                    />
                  </div>
                  {selectedCurrency == '1' &&
                    !isNaN(formik.values.discount) && (
                      <CurrencySubContent value={formik.values.discount} />
                    )}
                  <div className='flex gap-2'>
                    <TextField
                      component={motion.div}
                      variants={fadeUp(30, 'tween', 0.4, 0.5)}
                      initial='hidden'
                      animate='show'
                      viewport={{ once: true, amount: 0.25 }}
                      color='formColor'
                      variant='outlined'
                      fullWidth
                      id='contractName'
                      name='contractName'
                      label={t('common.fields.contractNumber')}
                      error={
                        formik.touched.contractName &&
                        Boolean(formik.errors.contractName)
                      }
                      helperText={
                        formik.touched.contractName &&
                        t(formik.errors.contractName)
                      }
                      value={formik.values.contractName}
                      onChange={onChangeContractNumber}
                      autoComplete='off'
                    />
                    <FormSelectField
                      formik={formik}
                      fieldName='type_id'
                      path='dictionary/contracttypes'
                      label={t('common.fields.contractType')}
                    />
                  </div>

                  <TextField
                    component={motion.div}
                    variants={fadeUp(30, 'tween', 0.4, 0.5)}
                    initial='hidden'
                    animate='show'
                    viewport={{ once: true, amount: 0.25 }}
                    color='formColor'
                    variant='outlined'
                    fullWidth
                    id='comment'
                    name='comment'
                    label={t('common.fields.comment')}
                    multiline
                    rows={5}
                    error={
                      formik.touched.comment && Boolean(formik.errors.comment)
                    }
                    helperText={
                      formik.touched.comment && t(formik.errors.comment)
                    }
                    value={formik.values.comment}
                    onChange={(event) => {
                      formik.setFieldValue('comment', event.target.value, true);
                    }}
                    autoComplete='off'
                  />
                </div>
              </div>
            </div>
          </div>

          {!isNaN(formik.values.month) &&
            !isNaN(formik.values.left) &&
            formik.values.date &&
            !isNaN(formik.values.interval) && (
              <Fragment>
                <div className='step-three-payment-tables-wrapper'>
                  <Tabs
                    value={tabValue}
                    onChange={(event, newValue) => setTabValue(newValue)}
                    className='contract-step-three-table-tabs'
                  >
                    <Tab
                      label={t('contract.step.three.automaticTable')}
                      value='automatic'
                    />
                    <Tab
                      label={t('contract.step.three.manuallyTable')}
                      value='manually'
                    />
                  </Tabs>
                </div>

                {tabValue == 'automatic' && (
                  <StepThreeTabOne
                    month={formik.values.month}
                    left={formik.values.left}
                    date={formik.values.date}
                    interval={formik.values.interval}
                    paymentDataList={paymentDataList}
                    setPaymentDataList={setPaymentDataList}
                    currency={selectedCurrency}
                  />
                )}

                {tabValue == 'manually' && (
                  <StepThreeTabTwo
                    month={formik.values.month}
                    left={formik.values.left}
                    date={formik.values.date}
                    interval={formik.values.interval}
                    paymentDataList={paymentDataList2}
                    setPaymentDataList={setPaymentDataList2}
                    currency={selectedCurrency}
                  />
                )}
              </Fragment>
            )}

          <div className='text-center my-4'>
            <Button
              onClick={back}
              color='inherit'
              variant='contained'
              className='!mr-2'
            >
              {t('common.button.back')}
            </Button>
            <Button
              color='success'
              variant='contained'
              className='!ml-2'
              onClick={handleNext}
            >
              {t('common.button.next')}
            </Button>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default memo(StepThree);
